"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = tslib_1.__importDefault(require("vue"));
const ChallengeStatus_1 = require("../../enums/ChallengeStatus");
const siteText_1 = tslib_1.__importDefault(require("../../mixins/siteText"));
const Slide_vue_1 = tslib_1.__importDefault(require("../Slide.vue"));
const sitetext_1 = require("../../filters/sitetext");
const ChallengeType_1 = require("../../enums/ChallengeType");
const ElementIds_1 = require("../../enums/ElementIds");
const Turnstile_vue_1 = tslib_1.__importDefault(require("../Turnstile.vue"));
const userTelemetry_1 = require("../../api/userTelemetry");
const ForgotLinks_vue_1 = tslib_1.__importDefault(require("../ForgotLinks.vue"));
const api_1 = require("../../api");
const IFDICResponse_1 = require("../../interfaces/IFDICResponse");
exports.default = vue_1.default.extend({
    name: 'username-and-password',
    props: {},
    data: () => {
        return {
            username: null,
            password: null,
            rememberUsername: false,
            mobileInfoPanel: null,
            showSheet: false,
            hasResetError: false,
            hasInvalidChallengeStatus: false,
            hasServerError: false,
            FUFPToggle: false,
            logoPath: '',
            widgetConfig: {
                background: [],
            },
            turnstileToken: '',
            turnstileError: '',
            fdic: new IFDICResponse_1.FDICResponse(),
        };
    },
    computed: {
        currentChallenge() {
            return this.$store.state.currentChallenge;
        },
        registrationRedirectUrl() {
            const redirect = `${this.$store.state.configuration.baseUrl}Registration`;
            return redirect;
        },
        openAccountRedirectUrl() {
            return this.getSiteText('DigitalAccountOpening.DisplayLink.URL');
        },
        showForgotPasswordLink() {
            return this.$store.getters.displayForgotPasswordLink;
        },
        showAccountOpeningLink() {
            return this.$store.getters.displayAccountOpeningLink;
        },
        showForgotUsernameLink() {
            return this.$store.getters.displayForgotUsernameLink;
        },
        ellipsisConfig() {
            return this.$store.getters.ellipsisConfig;
        },
        mobileInfoPanelClass() {
            var hiddenDesktop = 'isotope-hidden--desktop';
            var additionalStyling = this.showSheet ? 'info-sheet' : 'info-sheet hidden';
            return `${hiddenDesktop} ${additionalStyling}`;
        },
        wrongCredentials() {
            return this.$store.state.challengeStatus === ChallengeStatus_1.ChallengeStatus.InvalidCredentials;
        },
        shouldHideRegistration() {
            if (this.isMobile && this.$store.state.configuration.mobileRegistrationEnabled !== 'True') {
                return true;
            }
            if (this.$store.getters.disableDesktopRegistration) {
                return true;
            }
            if (!this.$store.getters.isNativeApplication && this.isOauthRedirect()) {
                return true;
            }
            return false;
        },
        submitting() {
            return this.$store.getters.isSubmittingChallenge || this.$store.getters.isSubmittingAuthenticatedModel;
        },
        errorMessage() {
            var _a;
            if (this.$store.getters.hasInvalidChallengeStatus) {
                return this.getSiteText(`ChallengeStatus.${this.currentChallengeStatus}`, (_a = this.currentChallenge.SessionInfo) === null || _a === void 0 ? void 0 : _a.Id);
            }
            return '';
        },
        isMobile() {
            return this.$store.getters.isMobile;
        },
        elementIds: () => ElementIds_1.ElementIds,
        bankName() {
            return this.$store.state.configuration.bankName;
        },
        desktopLoginLayers() {
            let layers = [];
            if (this.widgetConfig && this.widgetConfig.background.length > 0) {
                layers = this.widgetConfig.background;
            }
            return layers;
        },
        turnstileEnabled() {
            return this.$store.state.configuration.turnstileEnabled;
        },
        turnstileSiteKey() {
            return this.$store.state.configuration.turnstileSitekey;
        },
        submitDisabled() {
            return this.submitting || this.turnstileEnabled && this.turnstileToken === '';
        },
        displayServerError() {
            return this.hasServerError || this.turnstileEnabled && this.turnstileError !== '';
        },
        serverErrorMessage() {
            if (this.turnstileEnabled && this.turnstileError !== '')
                return this.getSiteText('UsernameAndPassword.Error.WithReference', this.turnstileError);
            return this.getSiteText('Error.Generic');
        },
        currentChallengeStatus() {
            return this.$store.state.challengeStatus;
        },
        isCypress() {
            return this.$store.state.isCypress;
        },
        enableRememberMe() {
            return this.$store.getters.enableRememberMe;
        },
        showFDIC() {
            return this.isMobile && this.fdic.mobile.login.isEnabled === true;
        },
        FDICTheme() {
            const signColor = this.fdic.mobile.login.signColor.toLowerCase();
            // if the signColor is set to WHITE, admin is configured for FDIC to be white on a dark background
            // this means the theme of the fdic-notice element should be dark.
            return signColor === 'white' ? 'dark' : 'light';
        },
    },
    mixins: [siteText_1.default],
    filters: {
        sitetext: sitetext_1.siteTextFilter,
    },
    methods: {
        async submitForm() {
            if (this.submitting) {
                return;
            }
            this.hasServerError = false;
            await this.$store.dispatch('resetErrorStatus');
            if (this.turnstileEnabled) {
                this.$store.commit('setTurnstileToken', this.turnstileToken);
            }
            const challenge = {
                ...this.currentChallenge,
                Username: this.$data.username,
                Password: this.$data.password,
            };
            await this.$store.dispatch('submitChallenge', challenge);
            if (this.$store.getters.hasInvalidChallengeStatus) {
                this.hasInvalidChallengeStatus = true;
                if (this.turnstileEnabled && this.currentChallengeStatus === ChallengeStatus_1.ChallengeStatus.InvalidCredentials) {
                    // Turnstile tokens are only good once, so if authentication fails, reset the turnstile widget to generate a new token
                    this.turnstileToken = '';
                    this.$refs.turnstile.reset();
                }
            }
            if (this.$store.getters.hasServerError) {
                this.hasServerError = true;
            }
        },
        getIconClassFromSiteText(siteTextKey) {
            const icon = this.getSiteText(siteTextKey);
            return `font-icon-${icon}`;
        },
        async toggleRememberMe(enabled) {
            this.rememberUsername = enabled;
            void userTelemetry_1.telemetry.custom({
                workflowName: userTelemetry_1.workflowName.retail_registration,
                action: userTelemetry_1.userAction.remember_me_checked,
                stepType: userTelemetry_1.stepType.entry,
                stepName: userTelemetry_1.stepName.login,
                eventProperties: {
                    'value': enabled,
                },
            });
            await this.$store.dispatch('setRememberUsername', this.rememberUsername);
        },
        toggleSheet(showSheetNewValue) {
            this.showSheet = showSheetNewValue;
        },
        contentToggled() {
            if (this.showSheet === false) {
                var bottomSheet = this.$refs.bottomSheetRef.$el;
                var element = bottomSheet.querySelector('.irisv-sheet__content--opened');
                if (element != null) {
                    element.classList.remove('irisv-sheet__content--opened');
                }
            }
        },
        rememberMeDesktopText() {
            return this.getSiteText('UsernameAndPassword.RememberUsername.Desktop.Message');
        },
        resetValidationError(changingUsername) {
            const skipReset = this.$store.getters.challengeHistory[this.$store.getters.challengeHistory.length - 2].ChallengeTypeValue === ChallengeType_1.ChallengeType.Tethered && !this.hasResetError;
            this.hasResetError = true;
            if (!skipReset && (this.$store.state.challengeStatus === ChallengeStatus_1.ChallengeStatus.InvalidCredentials ||
                this.$store.state.challengeStatus === ChallengeStatus_1.ChallengeStatus.LockedOut && changingUsername)) {
                this.hasInvalidChallengeStatus = false;
            }
        },
        ellipsisItemSelected({ selectedMenuItem: item }) {
            if (this.mobileInfoPanel !== null &&
                item.iconName === this.getSiteText('UsernameAndPassword.InfoPanel.Ellipsis.IconName') &&
                item.label === this.getSiteText('UsernameAndPassword.InfoPanel.Ellipsis.Label') &&
                item.href === '#') {
                this.toggleSheet(true);
            }
        },
        getReturnUrl() {
            const urlParams = new URLSearchParams(window.location.search);
            return urlParams.get('ReturnUrl');
        },
        getOAuthRedirectUri() {
            const returnUrl = this.getReturnUrl();
            if (returnUrl) {
                const internalUrlParams = new URLSearchParams(returnUrl);
                const redirect_uri = Array.from(internalUrlParams.keys()).find(x => x.toLowerCase() === 'redirect_uri' || x.toLowerCase().endsWith('?redirect_uri'));
                if (redirect_uri)
                    return internalUrlParams.get(redirect_uri);
            }
            return null;
        },
        isOauthRedirect() {
            const returnUrl = this.getReturnUrl();
            if (returnUrl) {
                const re = /^(?:(?:\/)?mobile)?(?:\/)?oauth\/authorize/;
                return re.test(returnUrl);
            }
            return false;
        },
        async setupThemeBuilderItems() {
            const alkamiThemesRef = window.Alkami.Themes;
            const baseAssetUrl = alkamiThemesRef.baseAssetUrl || `${alkamiThemesRef.baseUrl}/assets`;
            const themeConfigFromServer = await alkamiThemesRef.Config;
            const logoFileName = themeConfigFromServer.brandLogos.wide.fileName;
            if (logoFileName !== null && logoFileName !== undefined && logoFileName !== '') {
                this.logoPath = `${baseAssetUrl}/${logoFileName}`;
            }
            const widgetName = 'alkami.webapps.isotope';
            let widgetConfigFromServer;
            try {
                widgetConfigFromServer = await alkamiThemesRef.getWidgetConfig(widgetName);
            }
            catch (error) {
                // eslint-disable-next-line no-console
                console.log('This FI may not have configued the Login Page Brand Image in Theme Builder.', error);
                return;
            }
            if (widgetConfigFromServer && widgetConfigFromServer.background && widgetConfigFromServer.background.length === 2) {
                const loginPage = this.$refs.loginPage;
                this.widgetConfig = { ...widgetConfigFromServer };
                loginPage.style.setProperty('--widgetIsotopeColorBgLayer0', `${this.widgetConfig.background[0].color.bgColor}`);
                loginPage.style.setProperty('--widgetIsotopeImageAttachmentLayer1', `${this.widgetConfig.background[1].image.attachment}`);
                if (this.widgetConfig.background[1].image.fileName !== '') { // No need to set this css var if there is no file name and just causes a console error
                    loginPage.style.setProperty('--widgetIsotopeImageLayer1', `url(${alkamiThemesRef.baseWidgetUrl}/${widgetName}/assets/${this.widgetConfig.background[1].image.fileName})`);
                }
                loginPage.style.setProperty('--widgetIsotopeImagePositionXLayer1', `${this.widgetConfig.background[1].image.positionX}`);
                loginPage.style.setProperty('--widgetIsotopeImagePositionYLayer1', `${this.widgetConfig.background[1].image.positionY}`);
                loginPage.style.setProperty('--widgetIsotopeImageRepeatLayer1', `${this.widgetConfig.background[1].image.repeat}`);
                loginPage.style.setProperty('--widgetIsotopeImageSizeLayer1', `${this.widgetConfig.background[1].image.size}`);
                loginPage.style.setProperty('--widgetIsotopeImageOpacityLayer1', `${this.widgetConfig.background[1].image.opacity}`);
            }
        },
        setTurnstileToken(token) {
            this.turnstileError = '';
            this.turnstileToken = token;
        },
        setTurnstileError(err) {
            this.turnstileError = err;
        },
        disableTurnstile() {
            // Turnstile has hit an unrecoverable problem.  Disable to not block login attempts
            this.$store.commit('setTurnstileEnableState', false);
        },
        turnstileTokenExpired() {
            this.turnstileError = '';
            this.turnstileToken = '';
        },
        ellipsisToggled(open) {
            void userTelemetry_1.telemetry.custom({
                workflowName: userTelemetry_1.workflowName.retail_registration,
                action: userTelemetry_1.userAction.overflow_menu_clicked,
                stepType: userTelemetry_1.stepType.entry,
                stepName: userTelemetry_1.stepName.login,
                eventProperties: {
                    'value': open === true ? 'open' : 'close',
                },
            });
        },
        async goToRegistration() {
            try {
                await userTelemetry_1.telemetry.custom({
                    workflowName: userTelemetry_1.workflowName.retail_registration,
                    action: userTelemetry_1.userAction.register_account_clicked,
                    stepType: userTelemetry_1.stepType.entry,
                    stepName: userTelemetry_1.stepName.login,
                });
            }
            catch {
                // ignoring any exceptions
            }
            if (this.isCypress) {
                return;
            }
            document.location = this.registrationRedirectUrl;
        },
        async FDIC() {
            var _a;
            try {
                const response = await (0, api_1.GetFDICConfiguration)();
                this.fdic.update(response);
            }
            catch (ex) {
                // eslint-disable-next-line no-console
                console.warn('Error getting FDIC configuration.  Defaulting to off.', ex);
            }
            if (!this.isMobile)
                (_a = document.querySelector('.header iris-fdic-notice')) === null || _a === void 0 ? void 0 : _a.toggleAttribute('hidden', !this.fdic.desktop.login.isEnabled);
        },
    },
    components: {
        IsotopeSlide: Slide_vue_1.default,
        Turnstile: Turnstile_vue_1.default,
        ForgotLinks: ForgotLinks_vue_1.default,
    },
    async mounted() {
        var _a, _b, _c, _d, _e, _f;
        if (this.currentChallenge.Username && this.currentChallenge.Username.length) {
            this.username = this.currentChallenge.Username;
        }
        if (((_a = this.$store.getters.configuration.loginCredentials) === null || _a === void 0 ? void 0 : _a.UserName) !== '') {
            this.username = (_b = this.$store.getters.configuration.loginCredentials) === null || _b === void 0 ? void 0 : _b.UserName;
        }
        // set remembered username
        const rememberedUsername = this.$store.state.rememberedUsername;
        // make sure rememberedUsername doesn't have falsy value, set the checkbox
        if (rememberedUsername) {
            this.rememberUsername = true;
            this.username = rememberedUsername;
            this.$store.commit('setRememberUsername', true);
        }
        /*
            Lots of hacking going on to load the Info sheet on the page
                1) First need to check if the element is loaded by the theme or not
                    -> The div id is expected to always be "mobile_info_panel"
                2) If it is present, then add the info to the ellipsis dropdown
                3) Set the info button to trigger event to open sheet (done in click handler, method ellipsisItemSelected)
         */
        // check to see if FI has configured mobile info panel, if yes, add info sidesheet button
        var mobileInfoPanelElement = document.getElementById('mobile_info_panel');
        if (mobileInfoPanelElement) {
            this.mobileInfoPanel = mobileInfoPanelElement.innerHTML;
            const mobileInfoEllipsisConfig = {
                iconName: this.getSiteText('UsernameAndPassword.InfoPanel.Ellipsis.IconName'),
                label: this.getSiteText('UsernameAndPassword.InfoPanel.Ellipsis.Label'),
                href: '#',
                target: '_self',
            };
            // get ellipsis config from state
            var ellipsisConfig = this.$store.getters.ellipsisConfig;
            // add the info panel
            ellipsisConfig.push(mobileInfoEllipsisConfig);
            // update the state with new list
            this.$store.commit('updateEllipsisConfig', ellipsisConfig);
        }
        var helpLi = document.querySelector('a[href="/Content/Help/ShowVisitorContent?name=VisitorHelp"]');
        if (helpLi) {
            const event = new CustomEvent('helpLinkLoaded', {
                bubbles: true,
                cancelable: false,
            });
            this.$el.dispatchEvent(event);
        }
        let loadedEvent = new CustomEvent('UsernameAndPasswordUIInitialized', {
            bubbles: true,
            cancelable: false,
        });
        this.$el.dispatchEvent(loadedEvent);
        if (this.$store.getters.hasInvalidChallengeStatus) {
            this.hasInvalidChallengeStatus = true;
        }
        if (this.$store.getters.hasServerError) {
            this.hasServerError = true;
        }
        // Workaround for iris-menu-dropdown not setting a type on the button. A setTimeout is needed since this iris-vue component loads another iris-vue component and a nextTick will also not work here
        // Make a point to remove this once UX-Dev fixes a bug where quick action buttons should have a settable type.
        setTimeout(() => {
            var _a;
            (_a = document.querySelector('#ellipsis_menu button')) === null || _a === void 0 ? void 0 : _a.setAttribute('type', 'button');
        }, 0);
        // Workaround for the iris-switch not setting a type on its internal button - DEV-107201
        (_c = document.querySelector('#rememberMeCheckBox button')) === null || _c === void 0 ? void 0 : _c.setAttribute('type', 'button');
        // Workaround for iris-textfield-password not handling passthrough attributes
        (_d = document.querySelector('#password')) === null || _d === void 0 ? void 0 : _d.setAttribute('autocomplete', 'current-password');
        // Fixes for accessibility issues
        (_e = document.querySelector('body.Authentication h1#widget_title')) === null || _e === void 0 ? void 0 : _e.setAttribute('aria-hidden', 'true');
        (_f = document.querySelector('body.Authentication ul#widget_nav')) === null || _f === void 0 ? void 0 : _f.setAttribute('aria-hidden', 'true');
        // Fetch wide logo for theme builder themes
        let themeBuilderTheme = document.querySelector('body.theme--theme-builder');
        if (themeBuilderTheme) {
            await this.setupThemeBuilderItems();
        }
        // retrieve FDIC configuration and display logo if appropriate
        void this.FDIC();
    },
    beforeCreate() {
        document.body.classList.add('username-and-password');
    },
    beforeDestroy() {
        document.body.classList.remove('username-and-password');
    },
});
